import { 
  FaGlobe,
  FaBook,
  FaHandHoldingHeart,
  FaLeaf,
  FaPaw,
  FaPalette,
  FaHeartbeat,
  FaUsers,
  FaChild,
  FaMicroscope,
  FaBalanceScale,
  FaHandsHelping,
  FaLaptopCode,
  FaRobot,
  FaRainbow
} from 'react-icons/fa';
import React from 'react';

export const categories = [
  { id: 'all', name: 'All Causes', icon: <FaGlobe /> },
  { id: 'education', name: 'Education', icon: <FaBook /> },
  { id: 'humanitarian', name: 'Humanitarian', icon: <FaHandHoldingHeart /> },
  { id: 'environment', name: 'Environment', icon: <FaLeaf /> },
  { id: 'animals', name: 'Animal Welfare', icon: <FaPaw /> },
  { id: 'arts', name: 'Arts & Culture', icon: <FaPalette /> },
  { id: 'health', name: 'Health & Wellness', icon: <FaHeartbeat /> },
  { id: 'community', name: 'Community Development', icon: <FaUsers /> },
  { id: 'youth', name: 'Youth Programs', icon: <FaChild /> },
  { id: 'research', name: 'Research & Innovation', icon: <FaMicroscope /> },
  { id: 'social', name: 'Social Justice', icon: <FaBalanceScale /> },
  { id: 'disaster', name: 'Disaster Relief', icon: <FaHandsHelping /> },
  { id: 'tech', name: 'Technology', icon: <FaLaptopCode /> },
  { id: 'ai', name: 'AI Ethics', icon: <FaRobot /> },
  { id: 'lgbtq', name: 'LGBTQ+', icon: <FaRainbow /> }
]; 